<template>
  <span>
    <site-link
      v-if="canPurchaseAddOns"
      :to="addOnRoute"
      class="margin-right-md"
      @click="$posthog.capture('usage:add_ons_link_click')"
    >
      {{ addOnLabel }}
    </site-link>
    <site-link
      v-if="isShowingUpgrade"
      :to="{ name: 'plans' }"
      class="margin-right-md"
      @click="$posthog.capture('usage:plans_link_click')"
    >
      Upgrade
    </site-link>
    <site-link
      v-if="type === 'kit'"
      :to="$docs('/web/setup/use-kit', { hash: '#tune-your-kits' })"
      @click="$posthog.capture('usage:tune_your_kits_link_click')"
    >
      How to Tune Your Kits
    </site-link>
    <site-link
      v-else-if="type === 'npm'"
      :to="$docs('/web/dig-deeper/continuous-integration')"
      @click="$posthog.capture('usage:tune_your_ci_link_click')"
    >
      How to Tune Your CI
    </site-link>
  </span>
</template>

<script>
  import { addOnSectionRoute } from 'app/views/accounts/addOns/addOnResources'
  import { EventTrackingMixin } from 'app/mixins'

  export default {
    name: 'UsageActions',

    mixins: [EventTrackingMixin],

    props: {
      canPurchaseAddOns: {
        type: Boolean,
        default: false
      },
      isShowingUpgrade: {
        type: Boolean,
        default: true
      },
      type: {
        type: String,
        required: true
      }
    },

    computed: {
      addOnResource() {
        return this.type === 'npm' ? 'bandwidth' : 'pageviews'
      },

      addOnLabel() {
        return this.type === 'npm' ? 'Add Bandwidth' : 'Add Pageviews'
      },

      addOnRoute() {
        return addOnSectionRoute(this.addOnResource)
      }
    }
  }
</script>
